import script from "./company-inbox-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./company-inbox-modal.vue?vue&type=script&setup=true&lang=js"

import "./company-inbox-modal.vue?vue&type=style&index=0&id=904572ef&lang=scss"

const __exports__ = script;

export default __exports__